/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { BetDeEx } from "./BetDeEx";

export class BetDeExFactory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<BetDeEx> {
    return super.deploy(overrides || {}) as Promise<BetDeEx>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): BetDeEx {
    return super.attach(address) as BetDeEx;
  }
  connect(signer: Signer): BetDeExFactory {
    return super.connect(signer) as BetDeExFactory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BetDeEx {
    return new Contract(address, _abi, signerOrProvider) as BetDeEx;
  }
}

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_approver",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "_contractAddress",
        type: "address",
      },
    ],
    name: "ApproveBetEvent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_ender",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_contractAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint8",
        name: "_result",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_prize",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "string",
        name: "_description",
        type: "string",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "endTime",
        type: "uint256",
      },
    ],
    name: "EndBetContract",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_deployer",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address",
        name: "_contractAddress",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint8",
        name: "_category",
        type: "uint8",
      },
      {
        indexed: true,
        internalType: "uint8",
        name: "_subCategory",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "string",
        name: "_description",
        type: "string",
      },
    ],
    name: "NewBetEvent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_betAddress",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "_bettorAddress",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint8",
        name: "_choice",
        type: "uint8",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "_betTokensInExaEs",
        type: "uint256",
      },
    ],
    name: "NewBetting",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "Admin",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_contract",
        type: "address",
      },
    ],
    name: "approveBet",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "clonedContracts",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_description",
        type: "string",
      },
      {
        internalType: "uint8",
        name: "_category",
        type: "uint8",
      },
      {
        internalType: "uint8",
        name: "_subCategory",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "_minimumBetInExaEs",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_prizePercentPerThousand",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "_incentive",
        type: "uint8",
      },
      {
        internalType: "bool",
        name: "_isDrawPossible",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "_pauseTimestamp",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "_other",
        type: "string",
      },
    ],
    name: "createBet",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "dayswappers",
    outputs: [
      {
        internalType: "contract IDayswappers",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_endby",
        type: "address",
      },
      {
        internalType: "uint8",
        name: "_result",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "_prize",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "_description",
        type: "string",
      },
    ],
    name: "emitEndBetEvent",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_bettorAddress",
        type: "address",
      },
      {
        internalType: "uint8",
        name: "_choice",
        type: "uint8",
      },
      {
        internalType: "uint256",
        name: "_betTokensInExaEs",
        type: "uint256",
      },
    ],
    name: "emitNewBettingEvent",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getNumberOfBets",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "implementation",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "isAdmin",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "isBetValid",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "kycDapp",
    outputs: [
      {
        internalType: "contract IKycDapp",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "nrtManager",
    outputs: [
      {
        internalType: "contract INRTManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_buyer",
        type: "address",
      },
      {
        internalType: "address",
        name: "_seller",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_value",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_distribute",
        type: "uint256",
      },
    ],
    name: "payRewards",
    outputs: [],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [],
    name: "prepaidEs",
    outputs: [
      {
        internalType: "contract IPrepaidEs",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "randomnessManager",
    outputs: [
      {
        internalType: "contract RandomnessManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_username",
        type: "bytes32",
      },
    ],
    name: "resolveAddress",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "_username",
        type: "bytes32",
      },
    ],
    name: "resolveAddressStrict",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_wallet",
        type: "address",
      },
    ],
    name: "resolveUsername",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_wallet",
        type: "address",
      },
    ],
    name: "resolveUsernameStrict",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
      {
        internalType: "bool",
        name: "status",
        type: "bool",
      },
    ],
    name: "setAdmin",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_kycDapp",
        type: "address",
      },
    ],
    name: "setKycDapp",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_implementation",
        type: "address",
      },
    ],
    name: "storageFactory",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "timeallyClub",
    outputs: [
      {
        internalType: "contract ITimeAllyClub",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "timeallyManager",
    outputs: [
      {
        internalType: "contract ITimeAllyManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "timeallyPromotionalBucket",
    outputs: [
      {
        internalType: "contract ITimeAllyPromotionalBucket",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "validatorManager",
    outputs: [
      {
        internalType: "contract IValidatorManager",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";
